export default __webpack_public_path__ + "static/media/wrong.icon.3a62408b.svg";